import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { InternalTransfer, InternalTransferTypeEnumProvider, InternalTransferListViewModel, InternalTransferStatusEnumProvider } from "./internalTransferList-viewModel"

export class InternalTransferListView extends View<InternalTransferListViewModel>{
    GetViewUniqueId(): string {
        return "V-474D0BAF-34E2-4533-9B8D-84EE9EDD2F43"
    }
    loadHtml(): string {
        let element = require('./internalTransferList.html').default;
        let style = require('./internalTransferList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set internalTransfers(v: ObservableArray<InternalTransfer>) { this._internalTransfer = v; } public get internalTransfers(): ObservableArray<InternalTransfer> { return this._internalTransfer;} private _internalTransfer: ObservableArray<InternalTransfer>;
    public set internalTransferEnumProvider(v: InternalTransferTypeEnumProvider) { this._internalTransferEnumProvider = v; } public get internalTransferEnumProvider(): InternalTransferTypeEnumProvider { return this._internalTransferEnumProvider;} private _internalTransferEnumProvider: InternalTransferTypeEnumProvider;
    public set internalTransferStatusEnumProvider(v: InternalTransferStatusEnumProvider) { this._internalTransferStatusEnumProvider = v; } public get internalTransferStatusEnumProvider(): InternalTransferStatusEnumProvider { return this._internalTransferStatusEnumProvider; } private _internalTransferStatusEnumProvider: InternalTransferStatusEnumProvider;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
 
    createInternalTransfer () {
        this.dataContext.createInternalTransfer();
    }
 
    createCodeConversion () {
        this.dataContext.createCodeConversion();
    }
}
